import { ModelSagres } from "@/types/model-sagres";

/**
 * Recebido da API de usuários NestJS
 * @since 20240924
 */
export class Municipio extends ModelSagres {
  ID_MUNICIPIO: number;
  VERSAO: number;
  DATA_ULT_ALTERACAO: Date;
  USUARIO_ULT_ALTERACAO: string;
  VL_AREA: string;
  NU_CODIGO_IBGE: string;
  NM_NOME: string;
  VL_COEFICIENTE: number;
  DT_EMANCIPACAO: Date;
  IN_CEP: string;
  IN_LEITO: string;
  VL_POPULACAO: string;
  IN_VAGA_ESCOLAR: string;
  ID_UF: number;
  LONG: number;
  LAT: number;
  ID_MESORREGIAO: number;
  ID_MICROREGIAO: number;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.ID_MUNICIPIO = Number(obj.ID_MUNICIPIO);
      this.VERSAO = obj.VERSAO;
      if (obj.DATA_ULT_ALTERACAO)
        this.DATA_ULT_ALTERACAO = new Date(obj.DATA_ULT_ALTERACAO);
      this.USUARIO_ULT_ALTERACAO = obj.USUARIO_ULT_ALTERACAO;
      this.VL_AREA = obj.VL_AREA;
      this.NU_CODIGO_IBGE = obj.NU_CODIGO_IBGE;
      this.NM_NOME = obj.NM_NOME;
      this.VL_COEFICIENTE = obj.VL_COEFICIENTE;
      if (obj.DT_EMANCIPACAO)
        this.DT_EMANCIPACAO = new Date(obj.DT_EMANCIPACAO);
      this.IN_CEP = obj.IN_CEP;
      this.IN_LEITO = obj.IN_LEITO;
      this.VL_POPULACAO = obj.VL_POPULACAO;
      this.IN_VAGA_ESCOLAR = obj.IN_VAGA_ESCOLAR;
      this.ID_UF = Number(obj.ID_UF);
      this.LONG = obj.LONG;
      this.LAT = obj.LAT;
      this.ID_MESORREGIAO = obj.ID_MESORREGIAO;
      this.ID_MICROREGIAO = obj.ID_MICROREGIAO;
    }
  }
}
